import { render } from "./withdraw3.vue?vue&type=template&id=7f5a43ab&scoped=true"
import script from "./withdraw3.vue?vue&type=script&lang=js"
export * from "./withdraw3.vue?vue&type=script&lang=js"

import "./withdraw3.vue?vue&type=style&index=0&id=7f5a43ab&lang=less&scoped=true"

import exportComponent from "C:\\Users\\Administrator\\Desktop\\记录\\2508幸运28\\xingyun_vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f5a43ab"]])

export default __exports__